<template>
    <div>
        <div class='selected-option-text'>{{option_title}}</div>
            <div class='options-container'>
                <div v-for="option in options" :key='option'>
                    <div @click='changeOption(option)' :class="{'selected-option': selected_option.value == option.value}">
                        <div class='option-button'>{{option.value}}</div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    props: ['options', 'option_title'],
    emits: ['changeOptionListener'],
    data(){
        return{
            selected_option: {
            }
        }
    },
    methods:{
        changeOption(selected_option){
            this.selected_option = selected_option;
            this.$emit('changeOptionListener', selected_option, this.option_title);
        }
    },
}
</script>

<style lang="scss" scoped>
.selected-option-text{
    margin-bottom: 10px;
    font-size: 0.95rem;
    color: var(--black);
    text-transform: capitalize;
    font-weight: 600;
}

.options-container{
    display: flex;
    gap: 15px;
}

.option-button{
    border: solid 1px #868e96;
    // padding: 8px 12px;
    border-radius: 2px;
    cursor: pointer;
    min-width: 36px;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.selected-option{
//   border: 2px solid #A2A2A2;
    background-color: #343a40;
    color: #f8f9fa;
}

.option-button.out-of-stock{
    opacity: 0.5;
    background-color: #e9ecef;
    cursor: default;
}

</style>